import api from "../../../../store/AuthHeader";
import { JobCategory } from "../../JobCategories/models/JobCategory";

const getAll = (queryStr: any) => {
    return api.get("/JobCategory/GetAllJobCategories?" + queryStr);
};

const getJobCategoryById = (id: number) => {
    return api.get(`/JobCategory/GetJobCategoryById?id=${id}`);
};

const addJobCategory = (payload: JobCategory) => {
    return api.post("/JobCategory", payload);
};

const updateJobCategory = (id: number, payload: JobCategory) => {
    return api.put(`/JobCategory/${id}`, payload);
};

const deleteJobCategory = (itemToDeleteId: number) => {
    return api.delete(`/JobCategory/${itemToDeleteId}`);
};

const getAllJobCategoryList = () => {
    return api.get("/JobCategory/GetAllJobCategoryList");
}

export default {
    getAll,
    getJobCategoryById,
    addJobCategory,
    updateJobCategory,
    deleteJobCategory,
    getAllJobCategoryList
};